module.exports = __webpack_public_path__ + "img/05-white.84c3efa5.svg";